window.addEventListener("load", function () {
  let event = new Event("rerender-charts");
  const $toggleSidebarButton = document.getElementById("togglSidebarButton");
  const $sidebar = document.getElementById("sidebar");
  const $collapseIcon = document.querySelector("[data-sidebar-toggle-collapse-icon]");
  const $expandIcon = document.querySelector("[data-sidebar-toggle-expand-icon]");

  const collapseSidebar = (save = true, initial = false) => {
    document.querySelectorAll("[data-sidebar-collapse-hide]").forEach((el) => {
      el.classList.add("hidden");
      el.classList.add("opacity-0");
      if (initial) {
        el.classList.remove("opacity-0");
      } else {
        setTimeout(() => {
          el.classList.remove("opacity-0");
        }, 75);
      }
    });
    document.querySelectorAll("[data-sidebar-collapse-subitem]").forEach((el) => {
      el.classList.remove("pl-10");
    });
    // VP-1032: the group headings become rules when the rail is narrow — the
    // designs show a divider where the "Content"/"Community"/"Users" label sat.
    document.querySelectorAll("[data-sidebar-collapse-show]").forEach((el) => {
      el.classList.remove("hidden");
    });
    $sidebar.classList.remove("w-64");
    $sidebar.classList.add("w-16");
    $toggleSidebarButton.setAttribute("aria-expanded", "false");
    if (save) {
      if ($collapseIcon) $collapseIcon.classList.add("hidden");
      if ($expandIcon) $expandIcon.classList.remove("hidden");
      localStorage.setItem("sidebarExpanded", "false"); // Save state
    }

    this.document.dispatchEvent(event);
  };

  const expandSidebar = (save = true, initial = false) => {
    document.querySelectorAll("[data-sidebar-collapse-hide]").forEach((el) => {
      el.classList.remove("hidden");
      el.classList.add("opacity-0");
      if (initial) {
        el.classList.remove("opacity-0");
      } else {
        setTimeout(() => {
          el.classList.remove("opacity-0");
        }, 75);
      }
    });
    document.querySelectorAll("[data-sidebar-collapse-subitem]").forEach((el) => {
      el.classList.add("pl-10");
    });
    document.querySelectorAll("[data-sidebar-collapse-show]").forEach((el) => {
      el.classList.add("hidden");
    });
    $sidebar.classList.remove("w-16");
    $sidebar.classList.add("w-64");
    $toggleSidebarButton.setAttribute("aria-expanded", "true");
    if (save) {
      if ($collapseIcon) $collapseIcon.classList.remove("hidden");
      if ($expandIcon) $expandIcon.classList.add("hidden");
      localStorage.setItem("sidebarExpanded", "true"); // Save state
    }

    this.document.dispatchEvent(event);
  };

  // The initial state is applied inline in templates/includes/sidebar.html, so
  // the rail paints already collapsed rather than being corrected here — this
  // handler binds on window "load", far too late to avoid a visible flash.
  // Nothing re-applies it here: the DOM (aria-expanded) is the source of truth
  // from this point on, and re-running it would be a second initialisation.

  if ($toggleSidebarButton && $sidebar) {
    // Add click event to toggle button
    $toggleSidebarButton.addEventListener("click", () => {
      sessionStorage.setItem("sidebarHoverState", "false"); // Reset hover state on click
      if ($toggleSidebarButton.getAttribute("aria-expanded") === "true") {
        collapseSidebar(); // Save state permanently
      } else {
        expandSidebar(); // Save state permanently
      }
    });

    // Add hover functionality for temporary expansion
    let isTemporarilyExpanded = false;

    const canHover = window.matchMedia("(hover: hover) and (min-width: 1024px)");

    $sidebar.addEventListener("mouseenter", () => {
      if (!canHover.matches) return;
      if ($toggleSidebarButton.getAttribute("aria-expanded") === "false") {
        isTemporarilyExpanded = true;
        sessionStorage.setItem("sidebarHoverState", "true"); // Remember hover state
        expandSidebar(false); // Expand temporarily
      }
    });

    $sidebar.addEventListener("mouseleave", () => {
      if (!canHover.matches) return;
      if (isTemporarilyExpanded) {
        isTemporarilyExpanded = false;
        sessionStorage.setItem("sidebarHoverState", "false"); // Reset hover state
        collapseSidebar(false); // Collapse temporarily
      }
    });
  }
});
